import React, { useState, useEffect, useContext } from "react";
import classes from "./location.module.css";
import Axios from "../../../../../../Axios";
import { Urls } from "../../../../../../Urls";
import Loader from "../../../../../Loader";
import { toast } from "react-toastify";
import { next_page, save_details_api, Suggestion } from "../Utility";
import { isMobile } from "../../../../../../Constants";
//import AutoComplete from "../../../../../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/AutoComplete/AutoComplete";
import AutoComplete from "../../../../../Shared/AutosuggestV2/Autosuggestv2";
import { useMixPanelForTracking } from "../../../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../../../MyCompanyProfileContext";

/**
 * Step 3
 * LocationDetails component - review all unique locations from uploaded file
 * @param {number} step - Current step in the process
 * @param {React.SetStateAction} setStep - Function to set the current step (Now handles Mixpanel tracking)
 * @param {number} PreviosStep - Previous step in the process
 * @param {React.SetStateAction} setPreviosStep - Function to set the previous step
 * @param {Object} companyProfile - Company profile data
 * @param {Object} excel_details - Excel details data
 * @param {React.SetStateAction} setExcel_details - Function to set the excel details
 * @param {function} fetch_saved_details - Function to fetch saved details
 * @param {function} fetch_cleaning_details - Function to fetch cleaning details
 * @param {Array} location_list - List of locations
 * @param {React.SetStateAction} setLocation_list - Function to set the location list
 */
const LocationDetails = ({
  step = 2,
  setStep = "",
  PreviosStep = 0,
  setPreviosStep = "",
  companyProfile = {},
  excel_details = {},
  setExcel_details = "",
  fetch_saved_details = "",
  fetch_cleaning_details = "",
  location_list = [],
  setLocation_list = "",
  isBulkUpload,
  emailTemplate,
  superAdmins,
}) => {
  const [show, setshow] = useState(false);
  const [location_details, setLocation_details] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData
  );

  // Fetches and updates the location details based on the provided excel details and previous step
  useEffect(() => {
    if (excel_details && excel_details.blob_url && PreviosStep === 0) {
      fetch_cleaning_details(excel_details.blob_url, excel_details.excel_id);
    } else {
      fetch_saved_details(excel_details.excel_id);
    }
  }, [excel_details]);

  // Processes the location list and updates the location_details state
  useEffect(() => {
    if (!location_list?.length) return;

    const fetchLocation = async (suggestValue, companyId) => {
      try {
        const res = await Axios.get(
          `${Urls.Autocomplete.Get.getlist
          }?module_key=indents&suggest=${encodeURIComponent(
            suggestValue
          )}&limit=10&searchFields=new_locations&user_identifier=${companyId}`
        );
        return res.data?.value || [];
      } catch (err) {
        console.log(err);
        return [];
      }
    };

    const findMatchingLocation = (results, rawLoc, rawState) => {
      return (
        results.find(
          (x) => x.location.location === rawLoc && x.location.state === rawState
        ) || results[0]
      );
    };

    const getDedupeKey = (loc) => {
      const rawLoc = (loc["Raw Location"] || "").trim().toLowerCase();
      const rawState = (loc["Raw State"] || "").trim().toLowerCase();

      const code = (
        loc["Raw Location ID"] ||
        loc?.main_location?.location_code ||
        ""
      ).trim();

      if (code) {
        return `CODE::${code}::${rawLoc}::${rawState}`;
      }
      return `NOCODE::${rawLoc}::${rawState}`;
    };

    (async () => {
      setshow(true);
      const temp = [];
      const companyId = companyProfile.domain_data.company_id;

      for (let loc of location_list) {
        const key = getDedupeKey(loc);
        let alreadyExists = temp.find((x) => getDedupeKey(x) === key);

        if (!loc.main_location?.location) {
          const rawLoc = loc["Raw Location"];
          const rawState = loc["Raw State"];

          const code = (
            loc["Raw Location ID"] ||
            // loc?.main_location?.location_code ||
            ""
          ).trim();

          // ✅ use code if present, else name
          const suggestValue = code || rawLoc;

          const results = await fetchLocation(suggestValue, companyId);

          if (results.length > 0) {
            // if we searched by code, results should already be precise,
            // but still safe to match by name/state if possible
            const matched = findMatchingLocation(results, rawLoc, rawState);
            loc.main_location = matched || {};
          }

          if (!alreadyExists) {
            temp.push(loc);
          } else {
            alreadyExists.main_location = loc.main_location;
          }
        } else {
          if (!alreadyExists) temp.push(loc);
        }
      }

      setLocation_details(temp);
      setshow(false);
    })();
  }, [location_list]);

  /**
   * Sets the selected location for a specific location in the location_details array
   * @param {Object} loc - The location object
   * @param {string} e - The selected location value
   * @param {boolean} isOnChange - Indicates if the selection was made through onChange event
   * @returns {void}
   */
  const setSelectedOrigin = (loc, e, isOnChange = false) => {
    const temp_details =
      location_details?.map((location) => {
        if (loc.index === location.index) {
          if (isOnChange) {
            location.main_location = {
              ...location.main_location,
              location_name: e,
            };
          } else {
            location.main_location = e;
          }
        }
        return location;
      }) || [];

    setLocation_details(temp_details);
  };

  /**
   * Checks if all location details have a valid main_location
   * @returns {boolean} - True if all location details have a valid main_location, false otherwise
   */
  const check_location_details = () => {
    for (var i = 0; i < location_details.length; i++) {
      if (
        !location_details[i].main_location ||
        !location_details[i].main_location.location
      ) {
        return false;
      }
    }
    return true;
  };

  /**
   * Saves the location details and navigates to the next page.
   */
  const save_details = (locations) => {
    setshow(true);
    var unique_df = [],
      not_found_new = [],
      multistate = [],
      no_spellsugg = [];
    locations.map((loc) => {
      loc["user_input"] = "accepted";
      if (loc.type === "unique") {
        unique_df.push(loc);
      }
      if (loc.type === "not_found") {
        not_found_new.push(loc);
      }
      if (loc.type === "multistate") {
        multistate.push(loc);
      }
      if (loc.type === "no_spellsugg") {
        no_spellsugg.push(loc);
      }
    });
    if (unique_df && unique_df.length > 0) {
      var payload = {
        data: unique_df,
        key: "unique_df",
        excel_id: excel_details.excel_id,
      };
      save_details_api(payload)
        .then((res) => {
          setshow(false);
          // toast.success('Unique Saved')
        })
        .catch((err) => {
          setshow(false);
          console.log(err);
        });
    }
    if (not_found_new && not_found_new.length > 0) {
      var payload = {
        data: not_found_new,
        key: "not_found_new",
        excel_id: excel_details.excel_id,
      };
      save_details_api(payload)
        .then((res) => {
          setshow(false);
          // toast.success('Not Found Saved')
        })
        .catch((err) => {
          setshow(false);
          console.log(err);
        });
    }
    if (multistate && multistate.length > 0) {
      var payload = {
        data: multistate,
        key: "multistate",
        excel_id: excel_details.excel_id,
      };
      save_details_api(payload).then((res) => {
        // toast.success('MultiState Saved')
      });
    }
    if (no_spellsugg && no_spellsugg.length > 0) {
      var payload = {
        data: no_spellsugg,
        key: "no_spellsugg",
        excel_id: excel_details.excel_id,
      };
      save_details_api(payload).then((res) => {
        // toast.success('MultiState Saved')
      });
    }
    next_page({
      data: "truckandtransporter",
      excel_id: excel_details.excel_id,
      key: "page",
    })
      .then((res) => {
        setStep(3);
      })
      .catch((e) => console.log(e));
  };

  /**
   * Handles the save process and navigates to the next page.
   */
  const go_to_clean_truck = () => {
    const locations_to_resolve = location_details.filter(
      (item) => !item.main_location || !item.main_location.location
    ).length;

    // Activity([
    //   {
    //     screen: "Company Profile",
    //     module: "Freight Master Upload Excel",
    //     user_activity: `Location Screen: User clicked on Next Button`,
    //     timestamp: currentRequestTimeStamp(),
    //   },
    // ]);

    TrackMixPanel({
      ModuleName: "freight master",
      ScreenName: "location master bulk upload",
      Definition:
        "freight master popup location screen: user has clicked on next button",
      Data: `excel id: ${excel_details.excel_id}, total: ${location_details.length}, to resolve: ${locations_to_resolve}`,
    });

    if (!check_location_details()) {
      toast.info("Please Select location from dropdowns");
    } else {
      setExcel_details({
        ...excel_details,
        page: "truckandtransporter",
      });
      setLocation_list(location_details);
      save_details(location_details);
      setPreviosStep(2);
    }
  };

  /**
   * Handles the cancel process.
   */
  const cancelProcess = () => {
    if (window.confirm("Are you sure to cancel?")) {
      location_list.length = 0;
      next_page({
        data: "completed",
        excel_id: excel_details.excel_id,
        key: "page",
      }); //Imp
      document.getElementById("close_contactus1").click();
      toast.success("Process Cancelled Successfully");
    }
  };

  return (
    <div>
      <div className={`row`} style={{ height: isBulkUpload ? "55vh" : "" }}>
        <div className="col-md-12">
          <Loader show={show} />
          <div className={classes["location_headers"]}>
            <div>Sr.No.</div>
            <div className={classes["location_district"]}>Location ID</div>
            <div className={classes["location_name"]}>Location Name</div>
            <div className={classes["location_state"]}>Location State</div>
            <div className={classes["location_autosuggest"]}>
              Check Location
            </div>
          </div>
          <div className={classes["location_details"]}>
            {location_details.length > 0 ? (
              location_details.map((loc, index) => {
                return (
                  <div className={classes["location"]}>
                    <div style={{ paddingLeft: "8px" }}>
                      <b>{isMobile() ? "Sr.No.:" : ""}</b>
                      {index + 1}.
                    </div>
                    <div className={`${classes["location_state"]}`}>
                      <b>{isMobile() ? "Location District:" : ""}</b>{" "}
                      {/* {loc?.main_location?.location_code
                        ? loc?.main_location?.location_code
                        :  */}
                      {loc?.["Raw Location ID"]
                        ? loc?.["Raw Location ID"]
                        : "-"}
                    </div>
                    <div className={`${classes["location_name"]}`}>
                      <b>{isMobile() ? "Location Name:" : ""}</b>{" "}
                      {loc["Raw Location"]}
                    </div>
                    <div className={`${classes["location_district"]}`}>
                      <b>{isMobile() ? "Location State:" : ""}</b>{" "}
                      {loc["Raw State"]}
                    </div>
                    <div
                      className={`${loc["main_location"] && loc["main_location"].location
                        ? classes["location_autosuggest"]
                        : classes["error"]
                        }`}
                    >
                      <div>
                        <b>{isMobile() ? "Check Location:" : ""}</b>
                      </div>
                      <AutoComplete
                        key="location_key"
                        module_key="indents"
                        user_identifier={userDetails?.profile_company_id}
                        value={
                          loc?.main_location?.location_name
                            ? {
                              label: loc.main_location.location_name,
                              value: loc.main_location.location_name
                            }
                            : null
                        }
                        placeholder="Location Name/Code"
                        onChange={(val) =>
                          setSelectedOrigin(loc, val, true)   // typing
                        }
                        onSelect={(obj) =>
                          setSelectedOrigin(loc, obj)         // selection
                        }
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <center>No Location Found</center>
            )}
          </div>
        </div>
      </div>
      <center>
        <button
          className="btn btn-sm btn-danger mr-5"
          onClick={(e) => cancelProcess()}
        >
          Cancel
        </button>
        <button
          style={{ padding: "7px 13px" }}
          className="btn btn-sm btn-primary"
          disabled={show}
          onClick={(e) => go_to_clean_truck()}
        >
          Next
        </button>
      </center>
    </div>
  );
};

export default LocationDetails;
